// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qU5L","col":"styles_col__38ZNk"};